import { AbstractComponent } from '@/utils/sections/abstract-component';
import { register } from '@/utils/sections/registration';

export class EventsCalendar extends AbstractComponent {
  init() {
    this.options.filter = {
      events_categories: 'all',
    };

    this.emptyMessageEl = this.el.querySelector('[data-events-no-results]');
    this.items = this.el.querySelectorAll('[data-events-item]');
    this.sections = this.el.querySelectorAll('[data-events-section]');
    this.filterSelects = this.el.querySelectorAll('[data-filter-select]');

    if (this.filterSelects.length === 0) {
      return;
    }

    this.initSelects();
    this.filter(true);
  }

  initSelects() {
    this.filterSelects.forEach((el) => {
      const select = el.querySelector('select');

      el.addEventListener('change', (e) => {
        this.options.filter[el.dataset.filterSelect] = select.value;
        this.filter(true);
      });
    });
  }

  filter() {
    this.items.forEach((item) => {
      const category = item.dataset.categories.split('|');

      const match = this.options.filter.events_categories === 'all' || category.includes(this.options.filter.events_categories);

      if (!match) {
        this.hide(item);
      } else {
        this.show(item);
      }
    });

    this.sections.forEach((el) => {
      el.classList.toggle('is-hidden', !this.hasVisibleItems(el.querySelectorAll('[data-events-item]')));
    });

    this.emptyMessageEl.classList.toggle('is-hidden', this.hasVisibleItems(this.sections));
  }

  hasVisibleItems(els) {
    return Array.from(els).filter((item) => !item.classList.contains('is-hidden')).length > 0;
  }

  hide(item) {
    item.classList.add('is-hidden');
  }

  show(item) {
    item.classList.remove('is-hidden');
  }
}

register('events-calendar', EventsCalendar);
